import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ControlConfigComponent } from '../../../../app/lib/components/edit-control-config.component';
import { FormHelperService } from '../../../services/form-helper-service/form-helper.service';
import { SelectControlConfigOption } from '../select-control-config-option.model';
import { SelectControl } from '../select-control.model';
import { SelectControlConfigHelper } from './select-control-config.helper';

@Component({
    selector: 'vas-control-config-select',
    template: `
        <ion-item>
            <ion-label>Include in job card?</ion-label>
            <ion-toggle
                [formControl]="getFormControl('config.includeInJobCard')"
            ></ion-toggle>
        </ion-item>
        <ion-item>
            <ion-label>Is multi?</ion-label>
            <ion-toggle [formControl]="getFormControl('config.multi')"></ion-toggle>
        </ion-item>
        <ion-item>
            <ion-label>Options</ion-label>
            <ion-list item-content>
                <div *ngFor="let option of optionsFormGroups, let i = index">
                    <ion-item>
                        <ion-input [formControl]="option.get('value')"></ion-input>
                        <ion-input [formControl]="option.get('title')"></ion-input>
                        <ion-input [formControl]="option.get('score')"></ion-input>
                        <button
                            ion-button
                            item-end
                            (click)="onRemoveOption(i)"
                            color="danger"
                            outline>
                            <ion-icon name="remove"></ion-icon>
                        </button>
                    </ion-item>
                    <control-messages
                        [control]="option.get('value')"
                    ></control-messages>
                    <control-messages
                        [control]="option.get('title')"
                    ></control-messages>
                    <control-messages
                        [control]="option.get('score')"
                    ></control-messages>
                </div>
                <control-messages
                    [control]="optionsFormArray"
                ></control-messages>

                <ion-list-header>
                    Add new option
                </ion-list-header>
                <ion-item>
                    <ion-input
                        [formControl]="newOption.get('value')"
                        placeholder="Value"
                    ></ion-input>
                    <ion-input
                        [formControl]="newOption.get('title')"
                        placeholder="Label"
                    ></ion-input>
                    <ion-input
                        [formControl]="newOption.get('score')"
                        placeholder="Score"
                    ></ion-input>
                    <button
                        ion-button
                        item-end
                        (click)="addOption(newOption)"
                        color="primary"
                        [disabled]="newOption.invalid"
                    >
                        <ion-icon name="add"></ion-icon>
                    </button>
                </ion-item>
                <control-messages
                    [control]="newOption.get('value')"
                ></control-messages>
                <control-messages
                    [control]="newOption.get('title')"
                ></control-messages>
                <control-messages
                    [control]="newOption.get('score')"
                ></control-messages>
            </ion-list>
        </ion-item>
    `
})
export class SelectControlConfigComponent extends ControlConfigComponent {
    @Input() formGroup: FormGroup;
    @Input() data: SelectControl;

    newOption: FormGroup;

    ngOnInit(): void {
        this.initialiseOptions(this.getConfigValue('options'));
        this.resetNewOption();
    }

    get optionsFormArray(): FormArray {
        return this.formGroup.get('config.options') as FormArray;
    }

    /**
     * Returns the list options for editing
     * @returns {any}
     */
    get optionsFormGroups(): Array<FormGroup> {

        const optionFormArrayControl = this.optionsFormArray;

        if (!optionFormArrayControl) {
            return [];
        }
        return optionFormArrayControl.controls as Array<FormGroup>;
    }

    initialiseOptions(options: Array<SelectControlConfigOption> = []): void {

        const formArray = new FormArray(
            options.map(
                option => SelectControlConfigHelper.getOptionFormGroup(option)
            )
        );

        try {
            (this.formGroup.get('config') as FormGroup).removeControl('options');
            (this.formGroup.get('config') as FormGroup).addControl('options', formArray);
        } catch (e) {
            console.warn(e);
        }
    }

    /**
     * Adds the new option to the list
     * @param option
     */
    addOption(option: FormGroup): void {

        const errors = FormHelperService.getFormGroupErrors(option);

        if (errors.length > 0) {
            alert(errors[0]);
            return;
        }

        (this.formGroup.get('config.options') as FormArray).push(option);
        this.resetNewOption();
    }

    /**
     * Removes option from the list
     * @param position
     */
    onRemoveOption(position): void {
        (this.formGroup.get('config.options') as FormArray).removeAt(position);
    }

    /**
     * Resets the form controls for adding a new option
     */
    resetNewOption(): void {
        this.newOption = SelectControlConfigHelper.getOptionFormGroup({
            // tslint:disable-next-line:no-null-keyword
            score: null,
            title: '',
            value: ''
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/select/config/select-control-config.component.ts